<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <app-header></app-header>
        <main id="page-main">
            <header class="content-header">
                <div class="wrapper">

                    <div>
                        <h1>Wallet Passes</h1>
                        <p>Gestion des worspaces de connexion</p>
                    </div>

                    <div class="actions">

                    </div>

                </div>
            </header>
            <div class="content-body">

                <section>
                <div class="search">
                    <nav>
                        <ul>
                            <li><router-link :to="{ name: 'pass' }"><span>Passes</span></a></router-link></li>
                            <li><router-link :to="{ name: 'pass-template' }"><span>Templates</span></a></router-link></li>
                        </ul>
                    </nav>
                    <div><input type="text" placeholder="Recherche" v-model="query"/></div>
                </div>

                <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

                <div class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div v-bind:class="[ paginator.sort == 'id' ? 'active' : '', paginator.order ]">
                                <span data-sort="id" @click="setOrder($event)">id</span>
                            </div>
                            <div v-bind:class="[ paginator.sort == 'name' ? 'active' : '', paginator.order ]">
                                <span data-sort="name" @click="setOrder($event)">Nom</span>
                            </div>
                            <div><span data-sort="type_identifier" @click="setOrder($event)">Identifier</span></div>
                            <div><span>Provider</span></div>
                            <div><span>Restriction</span></div>
                            <div><span>Placeholder</span></div>
                            <div><span>Scope</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)">
                            <div></div>
                            <div class="picture">
                                <figure>
                                    <i class="icon icon-icon_passbook"></i>
                                </figure>
                            </div>
                            <div data-field="id">{{ item.id }}</div>
                            <div data-field="name"><strong>{{ item.name }}</strong><p>{{ item.ref_id }}</p></div>
                            <div data-field="type_identifier">{{ item.type_identifier }}</div>
                            <div data-field="provider">{{ item.provider }}</div>
                            <div data-field="restriction">{{ item.quantity_restriction }} / {{ item.redemption_restriction }} / {{ item.date_restriction }}</div>
                            <div data-field="values">{{ item.values }}</div>
                            <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                            <div class="actions">
                                <!--
                                <ul>
                                    <li><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                                -->
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
                </section>

                <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

            </div>
        </main>
    </div>
</template>
<script>
    import PassTemplateService from './PassTemplateService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return PassTemplateService;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/pass/IndexTemplate.vue